module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.7e75a583.png";